<template>
	<v-scale-screen width="1920" height="1080" :boxStyle="{ backgroundColor: '#001523' }">
		<dv-loading v-if="loading">Loading...</dv-loading>
		<template v-else>
			<div class="main">
				<div class="d-fleyarnx">
					<div class="head-title">
						<span class="title-text">油城智慧商圈</span>
					</div>
				</div>

				<div class="cts">
					<el-amap ref="map" class="amap-main" :center="[mapSQ.lng,mapSQ.lat]" map-style="amap://styles/blue" :zoom="14.2">
						<el-amap-polygon :path="polygons" fillColor="#5483ff" :visible="true" :editable="false"></el-amap-polygon>
						<el-amap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :icon="marker.iconPath"  @click="(e) => {clickArrayMarker(marker, e)}"></el-amap-marker>
					</el-amap>
					<div class="contents">
						<div class="con-left">

							<div class="con-block">
								<dv-border-box-12 :color="['#09557a', '#27dbe9']" backgroundColor="rgba(0, 21, 35,.8)"
									style="height: 310px">
									<div class="com-title">
										{{RightTopData.title}}
										<dv-decoration-3 style="width: 100px; height: 20px" />
									</div>
									<div>
										<RightTop :dataVal="RightTopData" @openShow="openShow" />
									</div>
								</dv-border-box-12>
							</div>

							<div class="con-block">
								<dv-border-box-12 :color="['#09557a', '#27dbe9']" backgroundColor="rgba(0, 21, 35,.8)"
									style="height: 280px">
									<div class="com-title">
										停车服务
										<!-- {{LeftCenterData.title}} -->
										<dv-decoration-3 style="width: 100px; height: 20px" />
									</div>
									<div>
										<LeftCenter :dataVal="LeftCenterData.config" @openShow="openShow" />
									</div>
								</dv-border-box-12>
							</div>

							<div class="con-block">
								<LeftBottom  :dataVal="LeftBottomData" @openShow="openShow" />
							</div>
						</div>
						<div class="con-center">
							<div class="centerSel" style="width: 480px;">
								
								<!-- <el-select @change="SerachArea" style="z-index: 9;margin-right: 10px;" v-model="selVal1" placeholder="请选择区域">
									<el-option v-for="item in selData1" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
								<el-select @change="SerachYetai" style="z-index: 9;" v-model="selVal2" placeholder="请选择业态类型">
									<el-option v-for="(item, index) in selData2" :key="index" :label="item.label"
										:value="item.value">
									</el-option>
								</el-select> -->
							</div>

							<div @click="showshangquan = true" style="position: absolute; top: 20px;color: #fff;z-index: 999;left: 0;right:0;text-align: center;font-size: 20px;background-color: rgba(0, 0, 0, 0.5);padding: 10px 0;cursor: pointer;">
								{{shqList[shqIndex].name}}<i class="el-icon-sort"></i>
							</div>

							<div class="centerButtom">
								<span>用户使用数量  124869人</span>
								<span>论坛留言数量  2764条</span>
								<span>订餐订单数量  36487单</span>
								<span>便民服务订单数量  6457条</span>
								<span>同城配送服务次数  6428次</span>
								<span>志愿者人数数量  328人</span>
								<span>便民服务累计服务人数  28769人</span>
							</div>
							<!-- <img class="right" src="../assets/right.png" /> -->
							<!-- <div id="allmap" style="width:100%;height: 400px;"></div> -->
							<!-- <bmap-gl style="height:680px;" class="map" :zoom="18" :mapStyle="mapStyle" scrollWheelZoom :center="{lng: 118.680675, lat: 37.440227}" @ready="readyHandler"></bmap-gl> -->
						</div>
						<div class="con-right">
							<div class="con-block">
								<dv-border-box-12 :color="['#09557a', '#27dbe9']" backgroundColor="rgba(0, 21, 35,.8)"
									style="height: 330px">
									<div class="com-title">
										商圈人流量展示
										<dv-decoration-3 style="width: 100px; height: 20px" />
									</div>
									<div>
										<LeftTop :dataVal="LeftTopData"></LeftTop>
									</div>
								</dv-border-box-12>
							</div>

							<div class="con-block">
								<dv-border-box-12 :color="['#09557a', '#27dbe9']" backgroundColor="rgba(0, 21, 35,.8)"
									style="height: 280px">
									<div class="com-title">
										入驻业态
										<dv-decoration-3 style="width: 100px; height: 20px" />
									</div>
									<!-- <div class="sh">
										<div class="sh-item t1">
											<div class="sh-item-div1">{{ toFixed(123456) }}</div>
											<div class="sh-item-div2">入驻数量</div>
										</div>
										<div class="sh-item t2">
											<div class="sh-item-div1">{{ toFixed(123456) }}</div>
											<div class="sh-item-div2">进店率</div>
										</div>
									</div> -->
									<div>
										<!-- <dv-capsule-chart
                      :config="catList"
                      style="width: 100%; height: 150px"
                    /> -->
										<RightCenter :dataVal="RightCenterData" />
									</div>
								</dv-border-box-12>
							</div>
							<div class="con-block">
								<dv-border-box-12 :color="['#09557a', '#27dbe9']" backgroundColor="rgba(0, 21, 35,.8)"
									style="height: 300px">
									<div class="com-title" @click="onshow= true" style="cursor: pointer;">
										实时客流({{ catList[catIndex].groupName }})
							
		
										<dv-decoration-3 style="width: 100px; height: 20px" />
									</div>
									<div class="rightBottom" style="overflow: hidden;height: 250px;padding-left: 5%;">
									<!-- <img src="../assets/img7.png" alt=""> -->
									<!-- <hk-video ref="hkvideo" :argument="videoArg" @windowChang="onWindChange" :width="370" :height="180"  :playMode="0"></hk-video>
										<div class="opt-view">
											<button class="btn" @click="preview">预览</button>
											<button class="btn" @click="stop">停止所有预览</button>
											<button class="btn" @click="setLayout('1x1')">1x1</button>
											<button class="btn" @click="setLayout('2x2')">2x2</button>
											<button class="btn" @click="setLayout('3x3')">3x3</button>
											<button class="btn" @click="setLayout('4x4')">4x4</button>
											<button class="btn" @click="stopList">停止当前窗口预览</button>
											<button class="btn" @click="changeMode">切换模式</button>
											<button class="btn" @click="startPlayBack">回放</button>
											<button class="btn" @click="drawText">叠加文字</button>
											<button class="btn" @click="setFullScreen">进入全屏</button>
											<button class="btn" @click="exitFullScreen">退出全屏</button>
										</div> -->
										<!-- <right-bottom v-if="luxiang.length>0" :dataVal="luxiang" @openShow="openShow" ></right-bottom> -->
										<dv-conical-column-chart :config="rightConfig" style="width:90%;height:230px;" />
									</div>

								</dv-border-box-12>
							</div>
						</div>




					</div>


				</div>
				<comp-table :title="dialogItem.title" :dataUrl="dialogItem.url" :visible="dialogTableVisible"  @close="close"></comp-table>
				<el-dialog :title="storeItem.name" :visible.sync="storeShow"  @close="storeFunHide" :modal-append-to-body='false' width="40%">
					<div style="display: flex; justify-content: space-between;">
						<img :src="storeItem.icon" width="200" alt="">
						<div style="flex:1; margin-left: 15px;font-size: 18px;margin-top: 10px;">
								<div style="font-weight: bold; font-size: 28px;">店铺：{{storeItem.name }}</div>
								<div style="margin-top: 10px;">地址：{{storeItem.address }}</div>
						</div>
					</div>
				 <view style="display: flex; justify-content: space-between;height: 100px;">
					
						<img :src="storeItem.icon" alt="">
						<view>地址：{{storeItem.address }}</view>
				 </view>
				</el-dialog>

				<el-dialog title="实时客流" :visible.sync="onshow"  @close="guanbiHide" :modal-append-to-body='false' width="40%">
				<div>
						<el-button type="primary" v-for="(item,index) in catList" :key="index" @click="xuanze(index)">{{item.groupName}}</el-button>
				</div>
				</el-dialog>

				<el-dialog title="选择商圈" :visible.sync="showshangquan"  @close="sqhide" :modal-append-to-body='false' width="40%">
				<div>
						<el-button type="primary" v-for="(item,index) in shqList" :key="index" @click="sqxuanze(index)">{{item.name}}</el-button>
				</div>
				</el-dialog>
			</div>
		</template>
	</v-scale-screen>
</template>

<script>
	import LeftTop from "./left-top.vue";
	import LeftCenter from "./left-center.vue";
	import LeftBottom from "./left-bottom.vue";
	import RightTop from "./right-top.vue";
	import RightCenter from "./right-center.vue";
	import RightBottom from "./right-bottom.vue";

	import hkVideo from "@/components/hkVideo/index.vue";
import compTable from "@/views/comp-table";
	import moni from "./moni.json";

	import {quan_getByDept,dict_getDictData,yeTai_page,order_page,order_getMoney,yeTai_parkPage,yeTai_getYeTaiType,hik_getRegions,hik_cameraSearch,hik_status,hik_camerasPreviewURLs, yeTai_remainSpaceNum, yeTai_countGroup, yeTai_passengerFlow} from '../../network/api/home'
	import {
		request
	} from "http";
	import {
		imgCd,
		imgGc,
		imgCy,
		imgTc,
		imgYl,
		imgJr,
		imgXx
	} from "@/components/imgbase";
	export default {
		name: "Home",
		components: {
			LeftTop,
			LeftCenter,
			LeftBottom,
			RightTop,
			RightCenter,
			RightBottom,
			compTable,
			hkVideo
		},
		data() {
			return {
				rightConfig: {
  data: [
    {
      name: '进客量',
      value: 0
    },
    {
      name: '出客量',
      value: 0
    },
    {
      name: '保有量',
      value: 0
    }
  ],
  img: [
    '/img/jin.png',
    '/img/chu.png',
    '/img/bao.png',
  ],
		showValue: true
},
onshow: false,
showshangquan: false,
catItem: {},
catList: [],
shqIndex: 0,
shqList: [],
				catIndex: 0,
				luxiang: [],
				dialogItem: {},
				dialogTableVisible: false,
				mapSQ:{}, // 显示当前地图的生活圈 坐标
				polygons: [], // 当前的地图四至
				markers: [], // 地图标点
				typeIndex: 0,
				LeftTopData: {},	//LeftTop
				LeftCenterData: {},
				LeftBottomData: {},
				RightTopData: {},
				RightCenterData: {},
				MapData: {
					center: [],
					markers: []
				},
				selData1: [{name: "全部生活圈",id: 'all'},],
				selVal1: 'all',
				selData2: [{label: "全部业态类型",value: 'all'},],
				selVal2: 'all',
				loading: true,
				center: [118.680675, 37.440227],
				levelShow: true,
				mapStyle: {
					styleId: "7990566ff17937167769b4164f5c8fc0",
				},
				icon1: '../assets/icon-cd.png',
				width1: 50,
				height1: 50,
				data1: [{
						geometry: {
							type: 'Point',
							coordinates: [118.686945, 37.43801],
						},
						properties: {
							icon: imgCd,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.679341, 37.438304],
						},
						properties: {
							icon: imgTc,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.680711, 37.439776],
						},
						properties: {
							icon: imgTc,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.681295, 37.439808],
						},
						properties: {
							icon: imgTc,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.683383, 37.439679],
						},
						properties: {
							icon: imgTc,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.678739, 37.441846],
						},
						properties: {
							icon: imgTc,
						}
					},

					{
						geometry: {
							type: 'Point',
							coordinates: [118.684201, 37.438046],
						},
						properties: {
							icon: imgGc,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.676457, 37.439801],
						},
						properties: {
							icon: imgCy,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.675653, 37.438189],
						},
						properties: {
							icon: imgCy,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.675474, 37.441585],
						},
						properties: {
							icon: imgCy,
						}
					},
					{
						geometry: {
							type: 'Point',
							coordinates: [118.678739, 37.441846],
						},
						properties: {
							icon: imgCy,
						}
					},

				],
				bowenData: [{
					geometry: {
						type: "Point",
						coordinates: [118.509831,37.46592],
					}
				}, {
					geometry: {
						type: "Point",
						coordinates: [118.578785,37.454693],
					}
				},],
				statusList:[],
				storeItem: {},
				storeShow: false,
			};
		},
		mounted() {
			console.log(this.$route.query.shqId,'Ccans孙菲菲')
			
			this.cancelLoading();
			// this.init();
			this.MapInit()
			this.getInfo()
			this.shuju()
			
		},
		methods: {
			shuju(){
			  quan_getByDept({deptId: 100}).then(res => {
					if(res.code == 0) {
						this.shqList = res.data
						if(res.data.length <= 1) {
							this.shqList.push({
								name: '商业大厦',
								deptId: -1
							})
						}
						
					console.log(this.shqList, '商圈')
					}
				})
			},
			xuanze(index) {
				this.guanbiHide()
					this.quyuDetail()
			},
			sqxuanze(index) {
				this.sqhide()
				if(this.shqList[index].deptId > 0) {
					

				this.mapSQ = this.shqList[index]
				let wz = JSON.parse(this.mapSQ.fanWei)
					this.polygons = wz.map (item => {
						return [item.longitude,item.latitude]
					})
					this.shqIndex = index

				this.getData()


				} else {
					alert('设备调试中')
				// 	this.$notify({
				// 		title: '提示',
				// 		message: '设备调试中...'
        // });
				}
			},
			sqhide() {
				this.showshangquan = false
			},
			guanbiHide() {
				this.onshow = false
			},
			storeFunHide() {
				this.storeShow = false
			},
			clickArrayMarker(marker){
				this.storeItem = marker
				this.storeShow = true
          // console.log(marker)
        },
			openShow(e) {
				if(e.name == 'RightTop') {
					this.dialogItem = {
						title: this.RightTopData.typeTitle,
						url: this.RightTopData.url
					}
				}
				if(e.name == 'LeftCenter') {
					let shqid = this.LeftCenterData.data[e.val].shqId
					this.dialogItem = {
						title: this.LeftCenterData.title,
						url: 'https://www.dyqykzshq.com/jmreport/view/817579456490143744?shqId='+shqid
					}
				}
				if(e.name == 'LeftBottom') {
					this.dialogItem = {
						title: '订单列表',
						url: 'https://www.dyqykzshq.com/jmreport/view/817592752261857280'
					}
				}
				if(e.name == 'RightBottom') {
					this.dialogItem = {
						title: '监控',
					}
				}
				
				this.dialogTableVisible = true
			},
			close() {
				this.dialogTableVisible = false
			},
			async getInfo() {
				let res1 = await quan_getByDept()
				if(res1.code == 0) {
					
					// this.selData1 = res1.data
					// this.mapSQ = res1.data[0]
					this.mapSQ = res1.data.find(item => item.id == 41)
					// this.selVal1 = res1.data[0].id
					this.selData1 = [
						...this.selData1,
						...res1.data
					]
					let wz = JSON.parse(this.mapSQ.fanWei)
					this.polygons = wz.map (item => {
						return [item.longitude,item.latitude]
					})
					 // 根据顶部id获取生活全
					if(this.$route.query.shqId) {
						this.selVal1 = Number(this.$route.query.shqId)
						this.SerachArea(Number(this.$route.query.shqId))
					}
				}
				
				let res2 = await dict_getDictData({dictType: 'yetai_type'})
				if(res2.code == 0) {
					// this.selData2 = res2.data
					this.selData2 = [
						...this.selData2,
						...res2.data
					]
					
				}
				if(res1.code ==0 && res2.code == 0) {
					this.getData()
				}
				let res4 = await dict_getDictData({dictType: 'trade_order_status'})
				if(res4?.code == 0) {
					this.statusList = res4.data
				}

				let res3 = await order_page({pageSize: 100})
				if(res3.code == 0) {
					// this.selData2 = res2.data
					let data = res3.data.list.map(item => {
						return [
							item.no.substr(0, 9) + '****' ,
							this.statusFun(item.status),
							this.dayjs(item.createTime).format('YYYY-MM-DD')
						]
					})

					// this.LeftBottomData = {
					// 	rowNum: 5,
					// 	columnWidth: [270,90],
					// 	data: data
					// }
				}

				

				let res5 = await hik_getRegions({pageNo:1,pageSize: 100})
				if(res5.code == 0 && res5.data.data.list.length>0) {
					// hik_cameraSearch
					let bh = []
					if(!this.RightCenterData.btData) {
						this.RightCenterData.btData = []
					}
					res5.data.data.list.forEach(item => {
						bh.push(item.indexCode)
						this.RightCenterData.btData.push(item.name.slice(0,2))
					})
					hik_cameraSearch({regionlndexCodes:bh.join(','),pageNo:1,pageSize: 1}).then(res => {
						
				// console.log(res,'14点13分')
						if(res.code == 0) {
							res.data.data.list.forEach((info,index) => {
								// this.RightCenterData.
									console.log(info,'15点00分+++++++++++++++++++++++++++++++++++++++++++++')
									if(index == 0) {
										hik_camerasPreviewURLs({indexCode:info.indexCode,pageNo:1,pageSize: 100,protocol:'ws'}).then(item => {
											console.log(item,'15点00分'+ (index+1))
											this.luxiang = item.data.data.url
										})
									}
								
								
							})
						}
						
					})
					
					// hik_status({regionld:bh.join(','),pageNo:1,pageSize: 100}).then(res => {
					// 	if(!this.RightCenterData.s1) { this.RightCenterData.s1 = [] }
					// 	if(!this.RightCenterData.s0) { this.RightCenterData.s0 = [] }
					// 	bh.forEach(item => {
					// 		let online0 = res.data.data.list.filter(its => its.online == 0 && its.regionIndexCode == item)
					// 		let online1 = res.data.data.list.filter(its => its.online == 1 && its.regionIndexCode == item)
					// 		this.RightCenterData.s1.push(online1.length??0)
					// 		this.RightCenterData.s0.push(online0.length??0)
					// 	})
						
					// 	console.log(this.RightCenterData,"++++++++++++++++++++++++++++++++++")
					// // console.log(res,'15点19分')
					// })
					// hik_status({regionld:bh.join(','),pageNo:1,pageSize: 100,status:0}).then(res => {
					// // console.log(res,'15点28分0')
					// })
				}
				
			},
			statusFun(e) {
				if(this.statusList.length > 0) {
				let [data] = this.statusList.filter(item => item.value == e)
				return data.label
			} else {
				return e
			}
			},

			quyuDetail() {
			  let params = {
					ids: this.catList[this.catIndex].groupId
				}
				yeTai_passengerFlow(params).then(res => {
					if(res.code == 0 && res.data.code == 0 && res.data.data.list.length>0) {
						this.catItem = res.data.data.list[0]
						this.rightConfig.data[0].value = res.data.data.list[0].flowInNum
						this.rightConfig.data[1].value = res.data.data.list[0].flowOutNum
						this.rightConfig.data[2].value = res.data.data.list[0].flowInNum - res.data.data.list[0].flowOutNum
					}
				})
			},
			async getData() {
				let data = {
					pageNo:1,
					pageSize:100,
					shqId: this.selVal1 =='all' ? 41:this.typeIndex
				}
				if(this.selVal2 !== 'all') {
					data.type = this.selVal2
				}
			
				let res = await yeTai_page(data)
					if(res.code ==0 ) {
						let updatePoints = res.data.list.map(item => {
							return {
								icon: item.imgUrl,
								address: item.address,
								name:item.name,
								id: item.id,
								width: "60",
								height: "60",
								position: [Number(item.lng),Number(item.lat)],
								iconPath: this.YTtype(item.type),
							}
						})
						this.markers = updatePoints
						
					}
					let data5 = {}
					if(this.selVal1 != 'all') {
						data5.shqId = this.selVal1
					}
				// let res5 = await order_getMoney(data5)
				// if(res5.code == 0) {
				// 	this.RightTopData = res5.data
				// 	this.RightTopData.url = 'https://www.dyqykzshq.com/jmreport/view/817595845573640192'
				// }
				let res6 = await yeTai_parkPage(data5)
				if(res6.code == 0) {
					// this.LeftCenterData = res6.data.list
					 
					// let data = res6.data.list.map( item => {
					// 	// let detailData = await yeTai_remainSpaceNum({parkIndexCode: item.shqId})
					// 	return [
					// 			item.name,
					// 			// detailData.data.data[0].totalPlace
					// 		]
						
					// })
					let data = []
					let dataDi = []
					res6.data.list.forEach( async (item,index) => {
					
						let resssdata = await yeTai_remainSpaceNum({parkIndexCode: item.shqId})
						data.push([item.name, resssdata.data.data[0].totalPlace, resssdata.data.data[0].leftPlace])
						dataDi.push({
          name: item.name,
          value: resssdata.data.data[0].totalPlace - resssdata.data.data[0].leftPlace
        })
					  
					})
					setTimeout(() => {
					console.log(data,'啛啛喳喳')
					this.LeftCenterData.config = {data:data, header: ['停车场名称', '总车位', '剩余车位'],columnWidth: [240,100,100], align: ['left','center','center']}

					this.LeftBottomData = {data:dataDi.sort(function(a, b){
        return b.value - a.value
    }).slice(0,10)}
					}, 1000);
				
					
				}
				setTimeout( async () => {
					let ye1 = await yeTai_page({userId:165})
					let ye2 = await yeTai_page({userId:166})
					console.log(ye1,'1111111111111111')
					console.log(ye2,'222222222222222')
					if(ye1.code == 0 && ye2.code == 0) {
						this.RightCenterData.s1 = ye1.data.total
						this.RightCenterData.s2 = ye2.data.total
					}
					console.log(this.RightCenterData,'@@@@@@@@@@')
				}, 1000);

				
				let res99 = await yeTai_countGroup(data5)
				if(res99.code == 0) {
					if(res99.code == 0 && res99.data.code == '0' && res99.data.data.total>0) {
						this.catList = res99.data.data.list
						await this.quyuDetail()
					}
				}
				if(res7.code == 0) {
					
					 
					let data7 = res7.data.data.map(item => {
						return {
							name: item.name,
							value: item.tcount
						}
					})
					this.RightTopData.typedata = data7.splice(0,5)
					this.RightTopData.typeTitle = res7.data.title
					// this.RightTopData.typeUrl = res7.data.url
					
				}
				
			},
			YTtype(e) {
				let url = ''
				switch(e) {
					case 0:
					url =  require("@/assets/icon-0.png")
					break;
					case 1:
					url = require("@/assets/icon-1.png")
					break;
					case 2:
					url = require("@/assets/icon-2.png")
					break;
					case 3:
					url = require("@/assets/icon-3.png")
					break;
					case 4:
					url = require("@/assets/icon-4.png")
					break;
					case 5:
					url = require("@/assets/icon-5.png")
					break;
					case 6:
					url = require("@/assets/icon-6.png")
					break;
					case 7:
					url = require("@/assets/icon-7.png")
					break;
					case 8:
					url = require("@/assets/icon-8.png")
					break;
					case 9:
					url = require("@/assets/icon-9.png")
					break;
					case 10:
					url = require("@/assets/icon-10.png")
					break;
					case 11:
					url = require("@/assets/icon-11.png")
					break;
					case 12:
					url = require("@/assets/icon-12.png")
					break;
					case 13:
					url = require("@/assets/icon-13.png")
					break;
					case 14:
					url = require("@/assets/icon-14.png")
					break;
					case 15:
					url = require("@/assets/icon-15.png")
					break;
					case 16:
					url = require("@/assets/icon-16.png")
					break;
					case 17:
					url = require("@/assets/icon-17.png")
					break;
					case 18:
					url = require("@/assets/icon-18.png")
					break;
					case 19:
					url = require("@/assets/icon-19.png")
					break;
					case 20:
					url = require("@/assets/icon-20.png")
					break;
					default:
					url = require("@/assets/icon-21.png")
					break;
				}
				return url
			},
			MapInit() {
				setTimeout(() => {
					if(moni.code == '200') {
					
						this.LeftTopData = moni.data[this.typeIndex].LeftTopData
						this.MapData = moni.data[this.typeIndex].MapData
				
					}
				}, 500);
			},
			SerachArea(e) {
				let data =this.selData1.find(item => item.id == this.selVal1)
				if(data.id == 'all') {
					this.mapSQ = this.selData1[1]
				} else {
					this.mapSQ = data
				}
				let wz = JSON.parse(this.mapSQ.fanWei)
					this.polygons = wz.map (item => {
						return [item.longitude,item.latitude]
					})
				// this.selVal2 = 0
				this.typeIndex = e
				this.getData()
				// this.MapInit()
			},
			SerachYetai(e) {
				this.getData()
				// this.MapInit()
			},
			zoomend(e) {
				let level = e.currentTarget.lastLevel;
				if (level > 18.2 || level < 17.9) {
					this.levelShow = false;
				} else {
					this.levelShow = true;
				}
			},
			clickMap(e) {
				// alert("map clicked");
				// console.log("click map: ", e);
			},
			cancelLoading() {
				setTimeout(() => {
					this.loading = false;
				}, 1500);
			},
			toFixed(val) {
				let num = parseFloat(val).toLocaleString("en", {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2,
				});
				let actualNum = num.split(".");
				if (actualNum[1] > 0) {
					return num;
				} else {
					return actualNum[0];
				}
			},
		},
	};
</script>



<style lang="scss">
/* 图标大小修改 */
  ::v-deep .amap-container img {
		max-width: 15px !important;
		max-height: 15px !important;
	}
	.d-flex {
		display: flex;
	}

	.font-main {
		font-family: "pengmenzhengdao";
	}

	.el-input__inner {
		background-color: transparent;
		border: 0px solid #fff;
		border-bottom: 2px solid #fff;
		color: #fff;
	}

	.main {
		padding: 16px 16px 0 16px;
		height: 100%;

		.head-title {
			width: 100%;
			height: 60px;
			background-image: url("../assets/head.png");
			background-size: cover;
			background-position: center center;
			position: relative;
			margin-bottom: 4px;
			text-align: center;

			.title-text {
				font-size: 36px;
				font-weight: 500;
				letter-spacing: 3px;
				line-height: 50px;
				width: 100%;
				// background: linear-gradient( #fff 0%, #dbe8fe 48.8525390625%, #b2ccfc 100%);
				background: linear-gradient(180deg,
						#0072ff 0%,
						#00eaff 48.8525390625%,
						#01aaff 100%);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				@extend .font-main;
			}
		}

		.cts {
			position: relative;
			padding: 0 16px;
			width: calc(100% - 32px);
			min-height: calc(100% - 95px);

			.amap-main {
				position: absolute;
				left: 0;
				right: 0;

				z-index: 1;
				width: calc(1920px - 32px);
			}
		}

		.contents {
			width: 100%;
			display: grid;
			overflow: hidden;
			grid-template-columns: 500px auto 500px;
			// grid-column-gap: 30px; 
			justify-content: space-between;

			.con-left,
			.con-right {
				// background:#001523;
				z-index: 1;
			}

			.con-center {
				padding: 0 16px 18px 16px;
				position: relative;
				width: 100%;

				.right {
					// position: absolute;
					right: 0;
					top: 0;
					z-index: 999;
					width: 200px;
					height: 820px;
				}

			}

			.com-title {
				color: #9dd8e6;
				@extend .font-main;
				display: flex;
				justify-content: space-between;
				padding: 15px 15px 10px;
				font-size: 18px;
			}

			.con-block {
				position: relative;
				margin-top: 12px;
				width: 100%;
			}

			.com-icon {
				display: flex;
				justify-content: center;
				text-align: center;

				>div {
					flex: 1;

					.f1,
					.f2 {
						@extend .font-main;
					}

					img {
						width: 100px;
						height: auto;
					}
				}
			}

			.sh {
				display: flex;
				height: 45px;
				padding: 0 16px;
				@extend .font-main;

				.sh-item {
					flex: 1;
					display: flex;
					flex-direction: column;
					justify-content: center;
					padding-left: 10px;

					&.t1 {
						// background: linear-gradient(to right, #00cbff, rgba(255, 0, 0, .1));
						background-image: linear-gradient(to right,
								rgba(0, 203, 255, 0.6),
								rgba(255, 0, 0, 0));
						border-left: 8px solid rgba(0, 203, 255, 1);

						.sh-item-div1 {
							color: rgba(0, 203, 255, 1);
						}
					}

					&.t2 {
						background-image: linear-gradient(to right,
								rgba(255, 204, 0, 0.6),
								rgba(255, 0, 0, 0));
						border-left: 8px solid rgba(255, 204, 0, 1);

						.sh-item-div1 {
							color: rgba(255, 204, 0, 1);
						}
					}

					.sh-item-div1 {
						font-size: 18px;
					}

					.sh-item-div2 {
						font-size: 14px;
					}
				}
			}
		}
	}

	.centerSel {
		z-index: 9;
		padding-top: 15px;
	}
	.centerButtom {
		position: absolute;
		bottom: 0;
		left: -100px;
		width: 700px;
			z-index: 999;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			padding:10px;
			background-color: rgba(0, 0, 0, 0.5);
			span {
				padding: 5px 0;
			}
	}

	.dv-dec-10,
	.dv-dec-10-s {
		width: 33.3%;
		height: 5px;
	}

	.dv-dec-10-s {
		transform: rotateY(180deg);
	}
</style>
